export const BackForAppConfiguration = {
    ApplicationId: "8POxUyQUzTKvipWr0jKahIbidQKfFT3haRRizVC1",
    ServerUrl: "https://parseapi.back4app.com/",
    JavascriptKey: "YWgi5OaPtvDKnXvkHsO1jKL3yxH8yD7hsPcOETfS",
}


// WEBPACK FOOTER //
// ./src/configurations/ParseConfiguration.js